import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SectionReveal, StaggerContainer, StaggerItem } from './SectionReveal';
export function SolutionSection() {
  const solutions = ['Entender cómo funciona tu vehículo.', 'Detectar problemas antes de que se vuelvan costosos.', 'Interpretar luces del tablero.', 'Hablar con más seguridad en talleres.', 'Comparar presupuestos.', 'Comprar usados con más confianza.', 'Prepararte para emergencias.', 'Ahorrar dinero a largo plazo.'];
  return <section className="py-20 md:py-32 bg-[#0a0a0a] border-b border-[#262626]" data-id="element-249">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-250">
        <SectionReveal className="text-center mb-16" data-id="element-251">
          <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-8" data-id="element-252">
            <span className="text-white block mb-2" data-id="element-253">
              La solución no es convertirte en mecánico.
            </span>
            <span className="text-[#F59E0B] block" data-id="element-254">
              La solución es entender lo básico.
            </span>
          </h2>
          <p className="text-xl text-[#9CA3AF] font-medium" data-id="element-255">
            Con este MegaPack vas a aprender a:
          </p>
        </SectionReveal>

        <StaggerContainer className="bg-[#171717] border border-[#262626] rounded-sm p-6 md:p-10 shadow-2xl" data-id="element-256">
          <div className="space-y-4" data-id="element-257">
            {solutions.map((solution, idx) => <StaggerItem key={idx} className="flex items-start gap-4 p-4 rounded-sm hover:bg-[#262626]/50 transition-colors" data-id="element-258">
                <CheckCircle2 className="w-6 h-6 text-[#F59E0B] flex-shrink-0 mt-0.5" data-id="element-259" />
                <span className="text-lg text-[#F5F5F5] font-medium" data-id="element-260">
                  {solution}
                </span>
              </StaggerItem>)}
          </div>
        </StaggerContainer>
      </div>
    </section>;
}